import { useCallback, useEffect, useState } from 'react';
import { useObserver, useLocalStore } from 'mobx-react';
import clientModels from '@/client/models';
import { getToken, handle } from '@/utils/Bridge';
import { LanguageSetting, queryObj } from '@/client/models/info';

export function useInfoInit() {
  const { info } = useLocalStore(() => clientModels);

  useEffect(() => {
    if (!info.token) {
      getToken()
        .then((res) => {
          if (typeof res?.data?.token === 'string') {
            info.updateToken(res?.data?.token);
            setTimeout(() => {
              console.log(`${window.location.href}&token=${res?.data?.token}`);
              window.$url = `${window.location.href}&token=${res?.data?.token}`;
            }, 1000);
          }
        })
        .catch((err) => {
          console.error(err);
          // 浏览器调试环境下设置
          if (queryObj.token) {
            info.updateToken(queryObj.token);
          } else {
            info.setQtReady(false);
          }
        });
      handle('updateToken', (data) => {
        if (typeof data?.token === 'string') {
          info.updateToken(data.token);
          window.$url = `${window.location.href}&token=${data.token}`;
        }
      });
    }
  }, []);

  useEffect(() => {
    if (info.token && !info.meetingInfo) info.getMeetingInfo();
  }, [info.token, info.meetingInfo]);
  return useObserver(() => {
    return {
      token: info.token,
      meetingInfo: info.meetingInfo,
      qtReady: info.qtReady,
      ableChangeLanguage: info.ableChangeLanguage,
      info,
    };
  });
}

// location.href = $url.replace(location.origin, 'https://10.219.156.201:7788');
export function useRecordStomp() {
  const { info, stomp } = useLocalStore(() => clientModels);
  const { channelId, startedConnected, ableChangeLanguage } = useObserver(() => {
    return {
      channelId: info.meetingInfo?.channelId,
      startedConnected: stomp.startedConnected,
      ableChangeLanguage: info.ableChangeLanguage,
    };
  });
  useEffect(() => {
    if (stomp.startedConnected && channelId) {
      stomp.connect({
        ableChangeLanguage,
        channelId,
        ...info.languageSettingParams,
      });
    } else {
      stomp.disconnect();
    }
  }, [
    channelId,
    startedConnected,
    info.languageSettingParams.language,
    info.languageSettingParams.translateTargetLanguage,
    ableChangeLanguage,
  ]);

  const connect = useCallback((linked: boolean) => {
    stomp.setStartedConnected(linked);
  }, []);

  useEffect(() => {
    window.addEventListener('beforeunload', () => {
      console.log('beforeunload-stomp---disconnect');
      stomp.disconnect();
    });
  }, []);

  return useObserver(() => {
    return {
      resMsg: stomp.responseBody,
      connect,
    };
  });
}
